export const productRoutes = {
  getCategories: "/admin/get-product-categories-only",
  createCategories: "/admin/create-product-category",
  updateCategory: "/admin/update-product-category/",
  deleteCategory: "/admin/delete-product-category/",
};
